import iconOne from '../../assets/service/1.png';
import iconTwo from '../../assets/service/2.png';
import iconThree from '../../assets/service/3.png';
import iconFour from '../../assets/service/4.png';

const ServicesData = [
    {
        'icon': iconOne,
        'title': 'Dentaduras',
        'description': 'Recupere o conforto e a estética do seu sorriso com dentaduras feitas sob medida, garantindo funcionalidade e naturalidade.,',
    },
    {
        'icon': iconTwo,
        'title': 'Implantes',
        'description': 'Substitua dentes perdidos com implantes dentários seguros e duradouros, devolvendo confiança e qualidade de vida,',
    },
    {
        'icon': iconThree,
        'title': 'Claraemento',
        'description': 'Ilumine o seu sorriso com tratamentos de clareamento profissional, eficazes e seguros para dentes mais brancos e radiantes.,',
    },
    {
        'icon': iconFour,
        'title': 'Tratamento de Canal',
        'description': 'Salve dentes comprometidos com tratamentos de canal precisos e indolores, mantendo a saúde bucal e prevenindo complicações futuras.,',
    }
]

export default ServicesData;